var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B73E8",
    stroke: "#1B73E8",
    strokeWidth: 0.2,
    d: "M2.41 13.893s-.158-.034-.263-.14a.47.47 0 0 1-.14-.426l.6-4.047a.5.5 0 0 1 .14-.28l6.58-6.52c.64-.64 1.686-.64 2.333 0l1.853 1.84a1.624 1.624 0 0 1 0 2.32l-6.546 6.487a.53.53 0 0 1-.28.14l-4.12.626H2.41Zm1.163-4.3L3.1 12.807l3.287-.5 6.426-6.374c.12-.12.187-.28.187-.453a.64.64 0 0 0-.187-.453l-1.853-1.84a.66.66 0 0 0-.927 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B73E8",
    stroke: "#1B73E8",
    strokeWidth: 0.2,
    d: "M11.214 8.72a.5.5 0 0 1-.353-.147L7.38 5.12a.497.497 0 0 1 0-.707.497.497 0 0 1 .707 0l3.48 3.453c.193.194.2.514 0 .707-.1.1-.227.147-.354.147Z"
  })));
};
export default SvgEdit;